module.exports = __webpack_public_path__ + "static/media/exercise.0672465d.svg";